import { create } from 'mobx-persist';
import localForage from 'localforage';

export default create({
  storage: localForage
});
